import { Component } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import * as RequestStatus from 'automation-ui-core/constants/RequestStatus';
import FetchSubscriptionTypesHOC from 'automation-ui-action-features/deprecated/set-subscriptions/FetchSubscriptionTypesHOC';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const LOADING_STATUSES = [RequestStatus.PENDING, RequestStatus.UNINITIALIZED];
class SetSubscriptionsActionDetail extends Component {
  render() {
    const {
      actionMetadata: {
        subscriptionId,
        optState
      },
      fetchSubscriptionTypesRequestStatus,
      subscriptionTypes
    } = this.props;
    const subscriptionType = subscriptionTypes.get(subscriptionId);
    const subscription = !subscriptionType ? LOADING_STATUSES.includes(fetchSubscriptionTypesRequestStatus) ? /*#__PURE__*/_jsx(SkeletonText, {}) : /*#__PURE__*/_jsx(MissingLabel, {
      type: "subscriptionType"
    }) : subscriptionType.name;
    switch (optState) {
      case 'OPT_IN':
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.set-subscriptions.action-detail.content.OPT_IN",
          options: {
            subscription
          }
        });
      case 'OPT_OUT':
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.set-subscriptions.action-detail.content.OPT_OUT",
          options: {
            subscription
          }
        });
      default:
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.set-subscriptions.action-detail.content.default",
          options: {
            subscription
          }
        });
    }
  }
}

/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
export default FetchSubscriptionTypesHOC(SetSubscriptionsActionDetail);